module.exports = __webpack_public_path__ + "img/bg2.5d1031e3.png";